import { createApi } from '@reduxjs/toolkit/query/react';

import { CategoryWiseProductsResponse } from '@/types/Category';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const enrollmentBYPApi = createApi({
  reducerPath: 'enrollmentBYP',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({
    basePath: '',
    useStrapiServer: true,
    cache: 'no-store',
  }),
  tagTypes: ['AllCategories', 'CategoryDetails'],
  endpoints: builder => ({
    // SB2 BYP Products = 2298
    // SB BYP Products = 2316
    getBYPProducts: builder.query<{ data: CategoryWiseProductsResponse }, void>({
      query: () => ({
        url: '/api/categories/shopping-experience/2316',
        next: { tags: ['CategoryDetails'] },
      }),

      transformResponse: (response: { data: CategoryWiseProductsResponse }, meta, arg) => {
        return response;
      },
      providesTags: ['CategoryDetails'],
    }),
  }),
});

export const { useGetBYPProductsQuery } = enrollmentBYPApi;
